<template>
  <div class="addOwner">
    <div class="top"></div>
    <div class="content">
      <div class="title">基本信息
        <!-- （必填） -->
        </div>
      <div class="cont">
        <span>货主姓名</span>
        <input type="text" placeholder="请输入10位以内的货主姓名" v-model="subData.name" />
      </div>
      <div class="cont">
        <span>联系方式</span>
        <input type="number" placeholder="请输入货主电话" v-model="subData.mobile" />
      </div>
      <div class="cont">
        <span>
          货主编号
          <span style="color:red">(可修改)</span>
        </span>
        <input type="text" placeholder="请输入货主编号" v-model="subData.supplier_sn" />
      </div>
      <div class="bottom" @click="save">保存</div>
    </div>
  </div>
</template>

<script>
import { isEmpty, isMobile } from "@/utils/validate";
import {
  owner_update,
  owner_create,
  owner_detail,
  owner_number
} from "@/api/work/manage/owner";
export default {
  name: "addOwner",
  data() {
    return {
      subData: {
        id: "",
        name: "",
        mobile: "",
        supplier_sn: ""
      },
      loading:true
    };
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.id) {
      to.meta.title = "编辑货主";
    } else {
      to.meta.title = "添加货主";
    }
    next();
  },
  created() {
    if (this.$route.query.id) {
      this.$route.meta.title = "编辑货主";
      this.subData.id = this.$route.query.id;
      this.getData();
    } else {
      this.$route.meta.title = "添加货主";
      this.getNumber();
    }
  },
  mounted() {},
  methods: {
    //获取添加货主编号
    getNumber() {
      owner_number().then(res => {
        if (res.code == 200) {
          this.subData.supplier_sn = res.data.num;
        }
      });
    },
    // 获取数据
    getData() {
      owner_detail({ id: this.subData.id }).then(res => {
        if (res.code == 200) {
          this.subData.id = res.data.id;
          this.subData.name = res.data.name;
          this.subData.mobile = res.data.mobile;
          this.subData.supplier_sn=res.data.supplier_sn
        }
      });
    },
    // 保存数据
    save() {
      if(!this.loading){
        return false
      }
      if (!this.subData.name) {
        this.$toast("请输入货主姓名！");
        return false;
      }
      if (!isMobile(this.subData.mobile)) {
        this.$toast("请输入正确的手机号码！");
        return false;
      }
      if (!this.subData.supplier_sn.trim()) {
        this.$toast("请输入货主编号！");
        return false;
      }
      if (this.subData.name.length>10) {
        this.$toast("请输入10位以内的货主姓名！");
        return false;
      }
       if (!/^[A-Za-z0-9]{1,30}$/g.test(this.subData.supplier_sn.trim())) {
        this.$toast("请输入少于30位由字母或数字组成的编号！");
        return false;
      }
      this.loading = false
      if(this.subData.id){
        owner_update(this.subData).then(res => {
          this.$toast.success(res.message);
          this.$router.go(-1);
        });
      }else{
        owner_create(this.subData).then(res => {
          this.$toast.success(res.message);
          this.$router.go(-1);
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.addOwner {
  .top {
    width: 100%;
    height: 3.6rem;
    background: url("../../../../assets/img/work/manage/buyer_bg.png") no-repeat
      center;
    background-size: 100% 100%;
  }
  .content {
    width: 6.5rem;
    margin: -1.8rem auto 0.78rem;
    background-color: #fff;
    padding: 0 0.3rem 0.3rem;
    border-radius: 0.16rem;
    overflow: hidden;
    .title {
      color: #727272;
      font-size: 0.24rem;
      margin-top: 0.44rem;
      margin-bottom: 0.09rem;
    }
    .cont {
      color: #343434;
      font-size: 0.28rem;
      border-bottom: #e8e8e8 solid 0.01rem;
      margin-top: 0.4rem;
      padding-bottom: 0.19rem;
      > span {
        display: inline-block;
        width: 2.24rem;
      }
    }
    .text {
      margin: 0.2rem auto 1.07rem;
      > div {
        width: 6.49rem;
        height: 3.26rem;
        border: 0.01rem #e4e4e4 solid;
      }
    }
    .bottom {
      width: 6.5rem;
      line-height: 1rem;
      background-color: #31b158;
      text-align: center;
      color: #fff;
      border-radius: 0.08rem;
      margin-top: 0.8rem;
    }
  }
}
</style>